export default {
  dbu_report_title: 'Report Title',
  dbu_report_preview_summary_card_title: 'Report List',
  dbu_report_preview_content_card_title: 'Report Content',
  dbu_report_share_new_report: 'Share new reports',
  dbu_report_share_market_report: 'Market Report Share',
  dbu_report_preview_back_btn_text: 'Back to edit',
  dbu_report_search_placeholder: 'Search by title',
  dbu_report_publish_success_tips: 'Shared successfully',
  dbu_report_publish_success_tips_desc: 'Thank you for your contribution to DataBrain!',
  dbu_report_publish_success_btn1_text: 'Ok, View my Report',
  dbu_report_publish_success_btn2_text: 'Back to Reports List',
  dbu_report_delete_confirm_title: 'Are you sure to delete this report?',
  dbu_report_delete_confirm_desc: 'It will not be restored after deletion.',
  dbu_report_uploader_title: 'Share your reports',
  dbu_report_file_cn: 'File in CN',
  dbu_report_file_en: 'File in EN',
  dbu_report_file: 'File',
  dbu_report_file_language: 'File Language',
  dbu_report_title_cn: 'Title in CN',
  dbu_report_title_placeholder_cn: 'Please input title in CN',
  dbu_report_title_en: 'Title in EN',
  dbu_report_title_placeholder_en: 'Please input title in EN',
  dbu_report_abstract_cn: 'Abstract in CN',
  dbu_report_abstract_placeholder_cn: 'Please input abstract in CN',
  dbu_report_abstract_en: 'Abstract in EN',
  dbu_report_abstract_placeholder_en: 'Please input abstract in EN',
  dbu_report_tag_cn: 'Tag in CN',
  dbu_report_tag_en: 'Tag in EN',
  dbu_report_tag_placeholder: 'Tags will be separated by , ; or |',
  dbu_report_cover: 'Cover',
  dbu_report_location: 'Location',
  dbu_report_location_level1: 'Category L1',
  dbu_report_location_level2: 'Category L2',
  dbu_report_location_level3: 'Category L3',
  dbu_report_location_placeholder: 'Please select location',
  dbu_report_permission: 'Permission',
  dbu_report_permission_placeholder: 'Please select permission',
  dbu_report_permission_all: 'All',
  dbu_report_author: 'Author_ID',
  dbu_report_author_number: 'Author {number}',
  dbu_report_author_placeholder: 'Please input author_id',
  dbu_report_author_org_structure: 'Org Structure',
  dbu_report_author_org_structure_placeholder: 'Please input org structure',
  dbu_report_add_author: 'Add Author',
  dbu_report_delete_author: 'Delete',
  dbu_report_clear_avatar: 'Clear avatar',
  dbu_report_update_image: 'Update Image',
  dbu_report_author_required_tips: 'Please complete the required fields before confirming',
  dbu_report_author_duplicate_tips: 'Please re-enter. The author_id is a duplicate.',
  dbu_report_download_enable: 'Download Enable',
  dbu_report_watermark_enable: 'Watermark Enable',
  dbu_report_form_tips: 'Brainy has generated the initial report details. Please review and refine as necessary.',
  dbu_report_upload_en_version_report: 'Upload the English version for more exposure',
  dbu_report_upload_cn_version_report: 'Upload the Chinese version for more exposure',
  dbu_report_add_update_error_tips1: 'One can only post report for themselves.',
};
